import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
  useMediaQuery,
  useTheme,
  Grid,
} from "@mui/material";
import "./Registartion.css";
import bgDesktop from "./Image/bg.jpg";
import bgMobile from "./Image/bg.jpg";
import logo from './Image/logoblack.png'
import { ProfileCreate } from "../Services/Services";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Link from "@mui/material/Link";

const RegistrationPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_no: "",
    address: "",
    password: "",
    confirmPassword: "",
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState("");

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "email") {
      if (!validateEmail(value)) {
        setEmailError("Please enter a valid email.");
      } else {
        setEmailError("");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, phone_no, address, password, confirmPassword } =
      formData;

    // Email validation
    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email");
      toast.warning("⚠️ Please enter a valid email");
      return;
    }

    // Password match check
    if (password !== confirmPassword) {
      toast.error(" Passwords do not match!");
      return;
    }

    setLoading(true);

    const payload = {
      name,
      email,
      phone_no,
      address,
      password,
      confirmPassword,
    };

    try {
      const response = await ProfileCreate(payload);

      toast.success("Registered successfully!");

      setFormData({
        name: "",
        email: "",
        phone_no: "",
        address: "",
        password: "",
        confirmPassword: "",
      });

      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (err) {
      console.error(" Registration Failed:", err);

      if (err.response && err.response.status === 409) {
        toast.error("⚠️ This email is already registered!");
      } else {
        toast.error("Registration failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
    className="register-card"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: { xs: "column", md: "row" }, // ✅ column in mobile, row in desktop
        justifyContent: "center",
        alignItems: "center",
        px: 2,
        backgroundImage: `linear-gradient(rgba(44, 43, 43, 0.5), rgba(35, 31, 31, 0.5)),
                        url(${isMobile ? bgMobile : bgDesktop})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
        overflow: "hidden",
        
      }}
    >
      <ToastContainer position="top-right" autoClose={2000} />
      <Box
        sx={{
          height: "auto",
          borderRadius: 4,
          px: 3,
          border: "2px solid #ccc",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          transform: isMobile ? "translateY(-20px)" : "none",
          width: { xs: "100%", sm: "590px" },
          border: "none",
        }}
      >
        {/* ✅ Logo */}
        <Box
          component="img"
          src={logo}
          alt="Logo"
          sx={{
            width: 120,
            height: "auto",
            objectFit: "contain",
            mb: 2,
          }}
        />
        <Typography
          variant="h4"
          align="center"
          className="register-title"
          sx={{ mb: 2 }}
        >
          Registration
        </Typography>

        <form onSubmit={handleSubmit} className="register-form">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Name"
                name="name"
                fullWidth
                required
                value={formData.name}
                onChange={handleChange}
                // margin="normal"
                gap={0}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    color: "white",
                    backgroundColor: "transparent !important",
                    borderRadius: 0,
                    "& fieldset": { borderColor: "white" },
                    "&:hover fieldset": { borderColor: "white" },
                    "&.Mui-focused fieldset": { borderColor: "white" },
                  },
                  "& .MuiInputLabel-root": { color: "white" },
                  "& .MuiInputLabel-root.Mui-focused": { color: "white" },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Email"
                name="email"
                type="email"
                fullWidth
                required
                value={formData.email}
                onChange={handleChange}
                // margin="normal"
                error={!!emailError}
                helperText={emailError}
                backgroundColor="transparent"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    color: "white",
                    backgroundColor: "transparent !important",
                    borderRadius: 0,
                    "& fieldset": { borderColor: "white" },
                    "&:hover fieldset": { borderColor: "white" },
                    "&.Mui-focused fieldset": { borderColor: "white" },
                  },
                  "& .MuiInputLabel-root": { color: "white" },
                  "& .MuiInputLabel-root.Mui-focused": { color: "white" },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Phone Number"
                name="phone_no"
                fullWidth
                required
                value={formData.phone_no}
                onChange={handleChange}
                // margin="normal"
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  maxLength: 10,
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    color: "white",
                    backgroundColor: "transparent !important",
                    borderRadius: 0,
                    "& fieldset": { borderColor: "white" },
                    "&:hover fieldset": { borderColor: "white" },
                    "&.Mui-focused fieldset": { borderColor: "white" },
                  },
                  "& .MuiInputLabel-root": { color: "white" },
                  "& .MuiInputLabel-root.Mui-focused": { color: "white" },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Address"
                name="address"
                fullWidth
                required
                value={formData.address}
                onChange={handleChange}
                // margin="normal"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    color: "white",
                    backgroundColor: "transparent !important",
                    borderRadius: 0,
                    "& fieldset": { borderColor: "white" },
                    "&:hover fieldset": { borderColor: "white" },
                    "&.Mui-focused fieldset": { borderColor: "white" },
                  },
                  "& .MuiInputLabel-root": { color: "white" },
                  "& .MuiInputLabel-root.Mui-focused": { color: "white" },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Password"
                name="password"
                type="password"
                fullWidth
                required
                value={formData.password}
                onChange={handleChange}
                // margin="normal"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    color: "white",
                    backgroundColor: "transparent !important",
                    borderRadius: 0,
                    "& fieldset": { borderColor: "white" },
                    "&:hover fieldset": { borderColor: "white" },
                    "&.Mui-focused fieldset": { borderColor: "white" },
                  },
                  "& .MuiInputLabel-root": { color: "white" },
                  "& .MuiInputLabel-root.Mui-focused": { color: "white" },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                fullWidth
                required
                value={formData.confirmPassword}
                onChange={handleChange}
                // margin="normal"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    color: "white",
                    backgroundColor: "transparent !important",
                    borderRadius: 0,
                    "& fieldset": { borderColor: "white" },
                    "&:hover fieldset": { borderColor: "white" },
                    "&.Mui-focused fieldset": { borderColor: "white" },
                  },
                  "& .MuiInputLabel-root": { color: "white" },
                  "& .MuiInputLabel-root.Mui-focused": { color: "white" },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                disabled={loading}
                className="register-button"
                sx={{
                  // mt: 3,
                  py: 1.5,
                  width: { xs: "100%", sm: "590px" },
                  fontWeight: "bold",
                  flexDirection: "column",
                  mx: "auto",
                  gap: 1,
                  borderRadius: 0,
                  backgroundColor: "#f9a51c !important",
                  boxShadow: "0 4px 12px rgba(25,118,210,0.4)",
                  "&:hover": {
                    backgroundColor: "#f9a51c !important",
                    boxShadow: "0 6px 20px rgba(17,82,147,0.5)",
                  },
                }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Register"
                )}
              </Button>
              <Link
                href="/"
                sx={{
                  color: "white",
                  backgroundColor: "none",
                  borderRadius: 0,
                  fontSize: "0.999rem",
                  width: { xs: "100%", sm: "590px" }, // ✅ responsive
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  flexDirection: "column",
                  textDecoration: "underline",
                  variant: "outlined",
                  // mb: 1,
                  mt: 2,
                }}
              >
                Login
              </Link>
            </Grid>
          </Grid>
        </form>

        {/* Powered by */}
        <Box
          sx={{
            mt: 2,
            p: 2,
            backgroundColor: "rgba(206, 183, 183, 0.45)",
            borderRadius: 0,
            textAlign: "center",
            width: { xs: "100%", sm: "570px" },
            
          }}
          className="powered-box"
        >
          <Typography
            variant="body2"
            sx={{
              color: "#ffffffcc",
              letterSpacing: 0.5,
              fontSize: "0.85rem",
            }}
          >
            Powered by{" "}
            <Box
              component="span"
              sx={{
                fontWeight: "bold",
                color: "#fff",
                letterSpacing: 0.5,
                fontSize: "0.85rem",
                "& a": {
                  color: "#fff",
                  textDecoration: "none",
                  borderBottom: "1px solid rgba(255,255,255,0.4)",
                  transition: "all 0.3s ease",
                },
              }}
            >
              <a
                href="https://www.yashvitech.com"
                target="_blank"
                rel="noreferrer"
              >
                YASHVITECH IT SOLUTION PVT. LTD.
              </a>
            </Box>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default RegistrationPage;
